export default __webpack_public_path__ + "static/media/430.3c253a72.png";